(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-contact-infromation"] && !Shopify.designMode) return;
  try {
              
  document.addEventListener("DOMContentLoaded", (event) => {
    let jsAccordian = document.querySelectorAll('.at-item');
    if(jsAccordian){
      jsAccordian.forEach(function(accodiantTab){
        accodiantTab.addEventListener('click',function(){
          this.classList.toggle('active')
        })
      })
    }
  });        
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-info"] && !Shopify.designMode) return;
  try {
              
  document.addEventListener("DOMContentLoaded", (event) => {
    let jsAccordian = document.querySelectorAll('.at-item');
    if(jsAccordian){
      jsAccordian.forEach(function(accodiantTab){
        accodiantTab.addEventListener('click',function(){
          this.classList.toggle('active')
        })
      })
    }
  });        
 
  } catch(e) { console.error(e); }
})();
})();
